import React, { Component } from 'react'
import press_1 from './pics/press1.svg'
import press_2 from './pics/press_2.png'
import member_1 from './pics/member_1.png'
import member_2 from './pics/member_2.png'
import { getMemberNews, getPressUpdate} from "../../../fetcher";
import './News.css'

export default class News extends Component {
    constructor(props) {
        super(props);

        this.state = {
            presslink:[],
            membernews_link:[],
            press_title:[],
            member_title:[],
            press_content:[],
            member_contenct:[],
            press_photo:[],
            member_photo:[]

        };

    }


    componentDidMount() {
        this.fetchNewsData();
    }
    fetchNewsData = async () => {
        try {
            //press update
            const pressData = await getPressUpdate();
            this.setState({ data: pressData });
            const newsData = await getMemberNews();
            this.setState({ data: newsData });
            let pl=[]
            let memberlink=[]
            let ptitle=[]
            let mtitle=[]
            let pcontent=[]
            let mcontent=[]
            let pphoto=[]
            let mphoto=[]


            const pressContentElements = document.querySelectorAll('.pressUpdate_content');

            pressContentElements.forEach((pressContentElement, index) => {
                if(!pressData.records)return
                const press = pressData.records[index].fields;
                const pressTitleElement = pressContentElement.querySelector('.pressUpdate_content_title');
                const pressDetailElement = pressContentElement.querySelector('.pressUpdate_content_detail');
                const pressImageElement = pressContentElement.querySelector('.pressUpdate_img');

                pressTitleElement.textContent = press.Title;
                ptitle.push(press.Title)
                if (press.Content.length > 240) {
                    // pressDetailElement.textContent = press.Content.substring(0, 240) + '...';
                    pcontent.push(press.Content.substring(0, 240) + '...')
                }
                else{
                    // pressDetailElement.textContent = press.Content;
                    pcontent.push(press.Content)
                }
                    

                if( press.Photo && press.Photo.length > 0) {
                    pressImageElement.src = press.Photo[0].url;
                    pphoto.push(press.Photo[0].url)
                }
                const pressUrl = pressContentElement.querySelector('.my-link-class')
                // pressUrl.href = press.Link;
                pl.push(press.Link)

            });

            //members' news
            const newsMNContentElements = document.querySelectorAll('.memberNews_content');
            newsMNContentElements.forEach((newsMNContentElement, index) => {
                if(!newsData.records)return
                const news = newsData.records[index].fields;
                const newsMNTitleElement = newsMNContentElement.querySelector('.memberNews_content_subtitle');
                const newsMNDetailElement = newsMNContentElement.querySelector('.memberNews_content_detail');
                const newsMNImageElement = newsMNContentElement.querySelector('.memberNews_content_img');
                newsMNTitleElement.textContent = news.Title;
                mtitle.push(news.Title)

                if (news.Content.length > 240) {
                    // newsMNDetailElement.textContent = news.Content.substring(0, 240) + '...';
                    mcontent.push(news.Content.substring(0, 240) + '...')
                }
                else{
                    // newsMNDetailElement.textContent = news.Content;
                    mcontent.push(news.Content)
                }
                   


                if( news.Photo && news.Photo.length > 0) {
                    newsMNImageElement.src = news.Photo[0].url;
                    mphoto.push(news.Photo[0].url)
                }
                const newsUrl = newsMNContentElement.querySelector('.my-link-class')
                // newsUrl.href = news.Link;
                console.log(news.Link)
                memberlink.push(news.Link)

            });
            this.setState({presslink:pl})
            this.setState({membernews_link:memberlink})

            this.setState({press_title:ptitle})
            this.setState({member_title:mtitle})

            this.setState({press_content:pcontent})
            this.setState({member_contenct:mcontent})

            this.setState({press_photo:pphoto})
            this.setState({member_photo:mphoto})

        } catch (error) {
            console.error(error);
        }
    };


    render() {
        return (
            <div>
                <div className='news_title'>
                    <h1 className='news_title_text'>Latest News</h1>
                    <hr className='speaker_hr'/>
                </div>
                <div className='pressUpdate_container'>
                    <h1 className='pressUpdate_title'>Press Update</h1>
                    <div className='pressUpdate_content'>
                        <img className='pressUpdate_img' src={press_1} alt="pic" />
                        <div className='pressUpdate_content_text'>
                            <a id="mylink" href={this.state.presslink[0]} className="my-link-class" target="_blank">
                                <h2 className='pressUpdate_content_title'>{this.state.press_title[0]}</h2>
                            </a>
                            <h4 className='pressUpdate_content_detail'>{this.state.press_content[0]} </h4>
                        </div>
                    </div>
                    <hr className='news_hr'/>
                    <div className='pressUpdate_content'>
                        <img className='pressUpdate_img' src={press_1} alt="pic" />
                        <div className='pressUpdate_content_text'>
                            <a id="mylink" href={this.state.presslink[1]}className="my-link-class" target="_blank">
                                <h2 className='pressUpdate_content_title'>{this.state.press_title[1]}</h2>
                            </a>
                            <h4 className='pressUpdate_content_detail'>{this.state.press_content[1]} </h4>
                        </div>
                        {/* <button class='more_button1'>Check More</button> */}
                    </div>
                    <a href="/newsblogs" style={{ textDecoration: 'none' }}>
                    <button class='more_button' ><div className="button-text">Check More</div> {' '}<img className='s-arrow' alt="pic" /></button>
                    </a>
                </div>

                <div className='memberNews_container'>
                    <h1 className='memberNews_content_title'>Member's News</h1>
                    <div className='memberNews_content'>
                        <img className='memberNews_content_img' src={press_1} alt="pic" />
                        <div className='memberNews_content_text'>
                            <a id="mylink" href={this.state.membernews_link[0]} className="my-link-class" target="_blank">
                                <h2 className='memberNews_content_subtitle'>{this.state.member_title[0]}</h2>
                            </a>
                            <h4 className='memberNews_content_detail'>{this.state.member_contenct[0]}</h4>
                        </div>
                    </div>
                    <hr className='membernews_hr'/>
                    <div className='memberNews_content'>
                        <img className='memberNews_content_img' src={press_1} alt="pic" />
                        <div className='memberNews_content_text'>
                            <a id="mylink" href={this.state.membernews_link[1]} className="my-link-class" target="_blank">
                                <h2 className='memberNews_content_subtitle'>{this.state.member_title[1]}</h2>
                            </a>
                            <h4 className='memberNews_content_detail'>{this.state.member_contenct[1]}</h4>
                        </div>
                    </div>
                    <a href="/newsblogs" style={{ textDecoration: 'none' }}>
                    <button class='more_button'><div className="button-text">Check More</div> {' '}<img className='s-arrow' alt="pic" /></button>
                    </a>
                </div>
            </div>
        )
    }
}